/*
  Wellness Anarchy Cart Drawer, v1 (09.09.2026)
  Zwei Aktionen, die Dawn nicht kennt:
    [data-wa-add="<variant_id>"]  Cross-Sell "Hinzufügen"
    [data-wa-swap]                 3-Monats-"Wechseln": neue Variante hinzufügen, alte Zeile entfernen
  Beide nutzen die Cart AJAX API mit "sections" und rendern über cart-drawer.renderContents(),
  damit Balken, Summen, Cross-Sell und Icon-Bubble aus Liquid neu kommen. Kein eigenes DOM-Gebastel.
  Reihenfolge beim Wechsel: erst hinzufügen, dann entfernen. Scheitert das Hinzufügen, bleibt der Beutel im Korb.
*/
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var ERROR_TEXT = 'Das hat nicht geklappt. Bitte noch einmal versuchen.';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function showError(text) {
    var el = document.getElementById('CartDrawer-CartErrors');
    if (el) el.textContent = text || '';
  }

  function render(json) {
    var d = drawer();
    if (d && json && json.sections && typeof d.renderContents === 'function') {
      d.renderContents(json);
    }
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: HEADERS, body: JSON.stringify(body) }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || json.status) {
          throw new Error(json.description || json.message || ('HTTP ' + res.status));
        }
        return json;
      });
    });
  }

  function addVariant(variantId, quantity, withSections) {
    var body = { items: [{ id: Number(variantId), quantity: quantity || 1 }] };
    if (withSections) {
      body.sections = SECTIONS;
      body.sections_url = window.location.pathname;
    }
    return post(window.routes.cart_add_url, body);
  }

  function changeLine(lineKey, quantity, withSections) {
    var body = { id: lineKey, quantity: quantity };
    if (withSections) {
      body.sections = SECTIONS;
      body.sections_url = window.location.pathname;
    }
    return post(window.routes.cart_change_url, body);
  }

  function onAdd(btn) {
    return addVariant(btn.dataset.waAdd, 1, true).then(render);
  }

  function onSwap(btn) {
    var qty = Number(btn.dataset.waQty) || 1;
    return addVariant(btn.dataset.waVariant, qty, false).then(function () {
      return changeLine(btn.dataset.waLineKey, 0, true);
    }).then(render);
  }

  document.addEventListener('click', function (event) {
    var add = event.target.closest('[data-wa-add]');
    var swap = event.target.closest('[data-wa-swap]');
    if (!add && !swap) return;
    if (!window.routes || !window.routes.cart_add_url) return;

    event.preventDefault();
    var btn = add || swap;
    if (btn.disabled) return;

    setBusy(btn, true);
    showError('');

    var action = add ? onAdd(add) : onSwap(swap);
    action.catch(function (err) {
      if (window.console) console.error('[wa-cart-drawer]', err);
      showError(ERROR_TEXT);
      setBusy(btn, false);
    });
  });
})();
